import { render, staticRenderFns } from "./SubjectShort.vue?vue&type=template&id=2152decb"
import script from "./SubjectShort.vue?vue&type=script&lang=js"
export * from "./SubjectShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports